export const PREVIEW = 'Preview';
export const EMPTY_LIST = 'Your lease document list is empty';
export const ADD_LEASE_DOCUMENT_BTN = 'Add Lease Document';

export const LEASE_DOCUMENTS = 'Lease Documents';
export const LEASE_DOCUMENTS_FORM = 'leaseDocuments';

export const FILE_TYPE_ERROR = 'Only PDF files are allowed';
export const FILE_SIZE_ERROR = '75 MB is the maximum allowed size for the file';
export const FILE_REQUIRED_ERROR = 'File is required';